/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from 'react'
import { useLocation } from 'react-router'
import { NavLink } from 'react-router-dom'
import SVG from 'react-inlinesvg'
import { toAbsoluteUrl, checkIsActive } from '../../_metronic/_helpers'
import { baseURLV1, KEY } from "../service/API.js";


import { useSelector } from "react-redux";

export function AsideMenuList({ layoutProps }) {
  const { authToken, accessTokenPrivilege } = useSelector((state) => state.auth);
  const [access, setAccess] = useState([]);

  const location = useLocation()
  const getMenuItemActive = (url, hasSubmenu = false) => {
    return checkIsActive(location, url)
      ? ` ${!hasSubmenu && 'menu-item-active'} menu-item-open `
      : ''
  }


  useEffect(() => {
  }, []);

  return (
    <>
      {/* begin::Menu Nav */}
      <ul className={`menu-nav ${layoutProps.ulClasses}`}>
        {/*begin::1 Level*/}
        {/*<li
          className={`menu-item ${getMenuItemActive('/dashboard', false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/dashboard">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl('/media/svg/icons/Design/Layers.svg')} />
            </span>
            <span className="menu-text">Dashboard</span>
          </NavLink>
        </li>*/}
        {<li
          className={`menu-item ${getMenuItemActive('/Report')}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/Report">
            <i className="menu-bullet menu-bullet-dot">
              <span />
            </i>
            <span className="menu-text">Report</span>
          </NavLink>
        </li>}


        {<li
          className={`menu-item ${getMenuItemActive('/SendCoupon')}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/SendCoupon">
            <i className="menu-bullet menu-bullet-dot">
              <span />
            </i>
            <span className="menu-text">Coupon management</span>
          </NavLink>
        </li>}
      </ul>
      {/* end::Menu Nav */}
    </>
  )
}
